export function scrollToSection(sectionId: string) {
  const section = document.getElementById(sectionId);
  if (section) {
    // Hauteur du header fixe + marge supplémentaire pour un meilleur espacement
    const headerHeight = 70; // hauteur du header (h-[70px])
    const additionalOffset = 20; // marge supplémentaire pour l'espacement visuel
    const totalOffset = headerHeight + additionalOffset;

    // Position de l'élément par rapport au haut de la page
    const elementPosition =
      section.getBoundingClientRect().top + window.pageYOffset;

    // Position finale avec l'offset
    const offsetPosition = elementPosition - totalOffset;

    // S'assurer que nous ne scrollons pas au-dessus du haut de la page
    const finalPosition = Math.max(0, offsetPosition);

    window.scrollTo({
      top: finalPosition,
      behavior: 'smooth',
    });
  }
}
